import styled from 'styled-components';

interface ColorExampleProps {
  r: number;
  g: number;
  b: number;
}

interface ContainerProps {
  loading: string;
}

export const Container = styled.div<ContainerProps>`
  opacity: ${(props) => (props.loading === 'true' ? 0 : 1)};
`;

export const ColorContainer = styled.div`
  padding: 3px;
  background: #f4f4f4;
  border-radius: 1px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer;
`;

export const ColorExample = styled.div<ColorExampleProps>`
  width: 36px;
  height: 14px;
  border-radius: 2px;
  background: rgba(
    ${(props) => props.r},
    ${(props) => props.g},
    ${(props) => props.b},
    1
  );
`;

export const Popover = styled.div`
  position: absolute;
  z-index: 2;
`;

export const Cover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;
